import React, { useMemo, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ExportDownload from "../components/ExportTemplate/ExportDownload";

const TemplateExport = (props) => {
  const navigate = useNavigate();
  const useQuery = () => {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
  };

  const obj = {
    name: useQuery().get("name") || "",
    brand: useQuery().get("brand") || "",
    pdfURL: useQuery().get("exportUrl"),
    mlrId: useQuery().get("mlrId"),
    id: useQuery().get("deckid"),
    campaign: useQuery().get("campaign"),
    country: useQuery().get("country"),
  };
  useEffect(() => {
    if (obj.name === "") {
      navigate("/edetail-manager");
    }
  }, []);
  return <>{useQuery().get("name") && <ExportDownload deckData={obj} />}</>;
};

export default TemplateExport;
